export default "__VITE_ASSET__70eAyc$Q__"